(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offhook-footer"]) return;
  try {
    
function openOffhookContact(){const panel=document.getElementById('offhook-contact');if(panel&&(location.hash==='#offhook-contact'||location.hash==='#contact_form'||panel.querySelector('[data-offhook-sent],.errors'))){panel.open=true;}}
openOffhookContact();window.addEventListener('hashchange',openOffhookContact);
document.addEventListener('click',event=>{if(event.target.closest('a[href="#offhook-contact"]')){const panel=document.getElementById('offhook-contact');if(panel)panel.open=true;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offhook-store"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('offhook-store')) {
  customElements.define('offhook-store', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const node=this.querySelector('[data-oh-data]');
      if(!node) return;
      this.data=JSON.parse(node.textContent);
      if(!this.data.variants.length) return;
      this.controller=new AbortController();
      this.form=this.querySelector('[data-oh-form]');
      this.button=this.querySelector('[data-oh-submit]');
      this.choices=[0,0,0];this.quantity=1;this.busy=false;
      this.money=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});
      const match=this.data.variants.findIndex(v=>String(v.id)===String(this.data.selected));
      if(match>=0)this.choices[0]=match;
      this.classList.add('is-enhanced');
      this.addEventListener('change',e=>{if(e.target.name==='quantity'){this.quantity=Number(e.target.value);this.update();}},{signal:this.controller.signal});
      this.addEventListener('click',e=>{
        const color=e.target.closest('[data-oh-color]');
        const gallery=e.target.closest('[data-oh-gallery]');
        const choose=e.target.closest('[data-oh-choose]');
        const gift=e.target.closest('[data-oh-gift]');
        if(color){const row=Number(color.closest('[data-oh-handset]').dataset.ohHandset)-1;this.choices[row]=Number(color.dataset.ohColor);this.update();this.showImage(this.choices[row]);}
        if(gallery)this.showImage(Number(gallery.dataset.ohGallery));
        if(choose){this.choices[0]=Number(choose.dataset.ohChoose);this.update();this.showImage(this.choices[0]);this.toOptions();}
        if(gift){this.quantity=2;this.form.querySelector('[name="quantity"][value="2"]').checked=true;this.update();this.toOptions();}
      },{signal:this.controller.signal});
      this.form.addEventListener('submit',e=>this.submit(e),{signal:this.controller.signal});
      this.showImage(this.choices[0]);this.update();
      const sticky=this.querySelector('[data-oh-sticky]');
      this.observer=new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>0;});
      this.observer.observe(this.form);
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.controller=null;}
    toOptions(){this.querySelector('#offhook-buy').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
    showImage(index){this.querySelectorAll('[data-oh-photo]').forEach(n=>{n.hidden=Number(n.dataset.ohPhoto)!==index;});this.querySelectorAll('[data-oh-gallery]').forEach(n=>n.setAttribute('aria-pressed',String(Number(n.dataset.ohGallery)===index)));}
    selected(){return this.choices.slice(0,this.quantity).map(i=>this.data.variants[i]);}
    format(value){return this.money.format(value/100);}
    update(){
      const variants=this.selected(),first=this.data.variants[this.choices[0]],total=variants.reduce((sum,v)=>sum+Number(v.price),0);
      this.querySelector('[data-oh-unit]').textContent=this.format(first.price);
      this.querySelector('[data-oh-total]').textContent=this.format(total);
      this.querySelector('[data-oh-sticky-total]').textContent=this.format(total);
      this.querySelector('[data-oh-sticky-description]').textContent=variants.map(v=>v.name+' / '+v.connector).join(' · ');
      this.querySelectorAll('[data-oh-handset]').forEach((row,i)=>{
        row.hidden=i>=this.quantity;const variant=this.data.variants[this.choices[i]];
        row.querySelector('[data-oh-color-name]').textContent=variant.name;
        row.querySelector('[data-oh-connector]').textContent=this.data.strings.connector+': '+variant.connector;
        row.querySelector('[data-oh-fit]').textContent=variant.note;
        row.querySelectorAll('[data-oh-color]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.ohColor)===this.choices[i])));
      });
      this.querySelectorAll('[data-oh-offer-price]').forEach(el=>{const n=Number(el.dataset.ohOfferPrice);const sum=this.choices.slice(0,n).reduce((s,i)=>s+Number(this.data.variants[i].price),0);el.textContent=this.format(sum);});
      this.querySelector('[data-oh-mix]').hidden=this.quantity===1;
      const ready=this.dataset.ready==='true',available=variants.every(v=>v.available);
      this.button.disabled=this.busy||!ready||!available;
      this.querySelector('[data-oh-submit-label]').textContent=this.busy?this.data.strings.adding:!ready?this.data.strings.soon:available?this.data.strings.add:this.data.strings.soldOut;
      this.form.querySelector('[name="id"]').value=String(first.id);
      if(this.dataset.updateUrl==='true'&&first.id){const url=new URL(location.href);url.searchParams.set('variant',String(first.id));history.replaceState({},'',url);}
    }
    async submit(event){
      event.preventDefault();if(this.button.disabled||this.busy)return;
      const error=this.querySelector('[data-oh-error]'),cartLink=this.querySelector('[data-oh-error-cart]');error.hidden=true;cartLink.hidden=true;
      const items=[];for(const variant of this.selected()){const previous=items.find(x=>x.id===String(variant.id));if(previous)previous.quantity++;else items.push({id:String(variant.id),quantity:1});}
      this.busy=true;this.update();
      try{
        const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||this.data.strings.error);
        location.assign(this.dataset.cartUrl);
      }catch(e){error.textContent=e instanceof TypeError?this.data.strings.network:(e.message||this.data.strings.error);error.hidden=false;cartLink.hidden=false;error.focus();this.busy=false;this.update();}
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
